<div class="checklist-items m-t-xs">
	@for (option of checklistOptions(); track option; let index = $index) {
		<div class="checklist-item">
			<div class="checklist-item-answer">
				<p>{{ option.question }}</p>
				<div class="answer-btn-group">
					<!--Need to explicitly check boolean values as true,
          false and null are a valid different answers-->
					<button
						mat-stroked-button
						class="au-mat-btn-xs success-answer-btn"
						[class.active]="option.answer === true"
						(click)="updateOptionAnswer(true, index)"
					>
						{{ 'ok' | translate }}
					</button>
					<button
						mat-stroked-button
						class="au-mat-btn-xs failed-answer-btn"
						[class.active]="option.answer === false"
						(click)="updateOptionAnswer(false, index)"
					>
						{{ 'failed' | translate }}
					</button>
				</div>
			</div>
			@if (option.answer !== null) {
				<div class="checklist-item-comment">
					@if (option.answer === false) {
						<input
							#inputElement
							type="text"
							[placeholder]="'what_failed_placeholder' | translate"
							[ngModel]="option.reason"
							(ngModelChange)="optionTextInputChanged($event, index, 'reason')"
							[ngModelOptions]="{ updateOn: 'blur' }"
							(keydown.enter)="inputElement.blur()"
						/>
					}
					@if (option.answer === true) {
						<input
							#inputElement
							type="text"
							[placeholder]="'type_comment_placeholder' | translate"
							[ngModel]="option.comment"
							(ngModelChange)="optionTextInputChanged($event, index, 'comment')"
							[ngModelOptions]="{ updateOn: 'blur' }"
							(keydown.enter)="inputElement.blur()"
						/>
					}
				</div>
			}
		</div>
	}
</div>
